<template>
  <time v-if="date">
    <template v-if="end && date !== end">
      {{ dateFormatted }} – {{ endFormatted }}
    </template>
    <template v-else>
      {{ dateFormatted }}
    </template>
  </time>
</template>

<script>
export default {
  name: 'DateTime',
  props: ['date', 'end'],
  computed: {
    dateParts() {
      return this.parseDate(this.date)
    },
    endParts() {
      return this.parseDate(this.end)
    },
    dateFormatted() {
      const { year, month, day } = this.dateParts
      return `${day}.${month}.${year}`
    },
    endFormatted() {
      const { year, month, day } = this.endParts
      return `${day}.${month}.${year}`
    }
  },
  methods: {
    parseDate(date) {
      if (!date) return ''
      let [, year, month, day] = date.match(/(\d{4})-(\d{2})-(\d{2})/)
      year = Number(year)
      month = Number(month)
      day = Number(day)
      return { year, month, day }
    }
  }
}
</script>
